<template>
  <div>
    <div>
      <span class="xbed-sub-title">管家信息账号查看</span>
    </div>
    <Breadcrumb :style="{margin: '24px 0'}">
      <BreadcrumbItem>麗家会</BreadcrumbItem>
      <BreadcrumbItem>管家信息账号查看</BreadcrumbItem>
    </Breadcrumb>

    <Tabs value="1" @on-click='resetChang'>
      <TabPane label="修改账号信息" name="1">
        <account-edit></account-edit>
      </TabPane>
      <TabPane label="身份信息验证" name="2">
        <check-id></check-id>
      </TabPane>
      <TabPane label="绑定门店" name="3">
        <bind-store></bind-store>
      </TabPane>
      <TabPane label="操作记录" name="4">
        <operation-record :dataInfo="dataInfo" @changePageSize="changePageSize" @changePage="changePage"></operation-record>
      </TabPane>
    </Tabs>
  </div> 
</template>
<script>
import accountEdit from './account-edit'
import operationRecord from './operation-record'
import bindStore from './bind-store'
import checkId from './check-id'
import API from "../../../api"
import Utils from '../../../utils'

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token")
    this.username = Utils.findFromLocalStorage("vue-username")
    this.env = Utils.findFromLocalStorage("env", "dev")
  },
  data() {
    return {
      // 操作记录
      dataInfo: {
        listCount:0,
        listPage:1,
        recordInfoList: []
      },
      queryParams:{
        page:1,
        size:10,
        cleanerId:Utils.getUrlParameterByName('id')
      },
    }
  },
  methods:{
    resetChang(name){
      switch (name) {
        case "4":
          this.queryRecordInfoList()
          break;
      
        default:
          break;
      }
    },
    // 操作记录
    async queryRecordInfoList () {
      let recordInfoList = (await API.omsAPI[this.env].cleaner.editHousekeeperAccount(this.queryParams,this.token)).data 
      this.dataInfo.listCount = recordInfoList.totalCount 
      this.dataInfo.recordInfoList = recordInfoList.content || []
    },
    changePageSize (param) {
      this.queryParams.size = param.size
      this.queryParams.page = 1
      this.queryRecordInfoList();
    },
    changePage (param) {
      this.queryParams.page = param.page
      this.queryRecordInfoList();    
    },
  },
  components:{
    'account-edit':accountEdit,
    'operation-record':operationRecord,
    'bind-store':bindStore,
    'check-id':checkId,
  }
}
</script>





// WEBPACK FOOTER //
// src/pages/cleaner/housekeeper-account-edit/index.vue